export enum Role {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  SERVICE_PROVIDER_ADMIN = 'SERVICE_PROVIDER_ADMIN',
  ENTERPRISE_ADMIN = 'ENTERPRISE_ADMIN',
  SITE_ADMIN = 'SITE_ADMIN',
  END_USER = 'END_USER',
  MSN = 'MSN',
  LBO = 'LBO',
  BT = 'BT',
  AD_HOC_CONF = 'AD_HOC_CONF',
  DEDICATED_CONF = 'DEDICATED_CONF',
  IVR_ASSISTANT = 'IVR_ASSISTANT',
  IVR_CALLBACK = 'IVR_CALLBACK',
  VOICE_MAIL = 'VOICE_MAIL',
  CALL_RECORDING = 'CALL_RECORDING',
  MOBILE_OFFICE = 'MOBILE_OFFICE',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  CALL_CENTER = 'CALL_CENTER',
  ACD_QUEUE = 'ACD_QUEUE',
  UC_COLLABORATION = 'UC_COLLABORATION',
}
